@if (location) {
  <address data-testid="address" [class.inline]="inline" [class.small]="small">
    <div class="title">
      @if (rideId && showRideId) {
        <span class="ride-id">{{ rideId }}</span>
      }
      @if (location.name) {
        <strong>{{ location.name }} </strong>
      }
    </div>
    @if (location.address) {
      <span>{{ location.address }}</span>
    }
    @if (location.address2) {
      <span>{{ location.address2 }}</span>
    }
    <div class="region">
      @if (location.city) {
        <span class="city">{{ location.city }}</span>
      }
      @if (location.state) {
        <span>{{ location.state }}</span>
      }
      @if (location.zipCode) {
        <span>{{ location.zipCode }}</span>
      }
    </div>
    @if (phoneNumber) {
      <div class="phone-number">
        <a href="tel:+1{{ phoneNumber }}">{{ phoneNumber }}</a>
      </div>
    }
  </address>
}
